import { __ } from '@wordpress/i18n';
import {PanelBody,__experimentalUnitControl as UnitControl, RangeControl, RadioControl} from '@wordpress/components';
import { VayuBlocksBackground,VayuBlockBorderFrame, VayuBlocksToggleControl, VayuBlocksCssFilters} from '@vayu-blocks';
import { VayuBlocksDevice,VayuBlocksDeviceControl } from '@vayu-blocks/device-control';
import { useState} from '@wordpress/element';
import { SlideButton } from '@vayu-blocks/global';

const Overlay = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const getView = VayuBlocksDevice();

    const [firstDesktop, setFirstDesktop] = useState(false);
    const [firstTablet, setFirstTablet] = useState(false);
    
    const changevalue = (data, value) => {

        const updatedAttributes = {
            ...attributes.position,
            [data]: {
               ...attributes.position?.[data],
               [getView]: value
            },
        };

        const isFirstRun = !attributes.position?.[data]?.[getView];
        const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;

        if (getView === 'Desktop') {
            if (isFirstRun || firstDesktop) {
                updatedAttributes[data]['Tablet'] = value;
                updatedAttributes[data]['Mobile'] = value;
                localStorage.setItem('firstTablet', 'true');
                setFirstTablet(true);
                setFirstDesktop(true);
            }
        } else if (getView === 'Tablet') {
            if (isTabletFirstRun) {
                updatedAttributes[data]['Mobile'] = value;
                localStorage.removeItem('firstTablet');
                setFirstTablet(true);
                setFirstDesktop(false);
            }
        } else {
            setFirstTablet(false);
            setFirstDesktop(false);
        }

        setAttributes({ position: updatedAttributes });

    }
    
    return (
        
            <div class="vayu_blocks_image-flip-settings_main vayu_blocks_image-settings_main">
                
                <PanelBody title={__('Overlay','vayu-blocks')} opened={openPanels['overlay-overlay']} onToggle={() => onTogglePanel('overlay-overlay')}>

                    <VayuBlocksToggleControl
                       label={__('Overlay', 'vayu-blocks')}
                       checked={attributes.overlayshow}
                       onChange={(value) => setAttributes({ overlayshow: value })}
                    />

                    {attributes.overlayshow && (
                        <>

                            <RadioControl
                                label={__('Show Overlay', 'vayu-blocks')}
                                selected={attributes.overlayHoverMode || 'always'}
                                options={[
                                    { label: __('Always', 'vayu-blocks'), value: 'always' },
                                    { label: __('On Hover', 'vayu-blocks'), value: 'hover' },
                                ]}
                                onChange={(value) => setAttributes({ overlayHoverMode: value })}
                            />

                            <VayuBlocksToggleControl
                                label={__('Content Animation', 'vayu-blocks')}
                                checked={attributes.contentani}
                                onChange={(value) => setAttributes({ contentani: value })}
                            />

                            <VayuBlocksBackground
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['gradient'],
                                        label: 'Overlay',
                                        key:'overlaycolor',
                                        value:attributes.overlaycolor,
                                    },
                                    {
                                        active: ['gradient'],
                                        label: 'Hover',
                                        key:'overlayhvrcolor',
                                        value:attributes.overlayhvrcolor,
                                    },
                                ]}
                            />
                            
                            <RangeControl
                                __next40pxDefaultSize={true}
                                __nextHasNoMarginBottom={true}
                                label={__('Opacity', 'vayu-blocks')}
                                allowReset={true}
                                marks
                                withInputField={false}
                                initialPosition={ 5 }
                                max={ 10 }
                                min={ 0 }
                                value={ attributes.overlayopacity *10}
                                onChange={ (value) => setAttributes({overlayopacity:value/10})}
                            />

                            <VayuBlocksCssFilters 
                                data = {{key: 'filter', value:attributes.filter}}
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                headingLabel = "Backdrop Filter"
                            />
                        </>
                    )}
                
                </PanelBody >

                <PanelBody title={__('Border & Frame','vayu-blocks')} opened={openPanels['overlay-frame']} onToggle={() => onTogglePanel('overlay-frame')}>

                    {attributes.parentBlock === "vayu-blocks/advance-slider" && (
                        <>

                        <VayuBlocksToggleControl
                            label={__('Border Frame', 'vayu-blocks')}
                            checked={attributes.borderframe}
                            onChange={(value) => setAttributes({ borderframe: value })}
                        />
                            <p>If this is on, the global frame will be removed.</p>
                        </>
                    )}

                    {attributes.parentBlock === "vayu-blocks/advance-slider" ? (
                        attributes.borderframe ? (
                            <VayuBlockBorderFrame
                                frameData={attributes.frameData}
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                dataKey="frameData"
                            />
                        ) : null
                    ) : (
                        <VayuBlockBorderFrame
                            frameData={attributes.frameData}
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            dataKey="frameData"
                        />
                    )}

                                            

                </PanelBody>

                <PanelBody title={__('Position/Width', 'vayu-blocks')} opened={openPanels['overlay-position']} onToggle={() => onTogglePanel('overlay-position')}>
                
                    <>

                        <span> {<VayuBlocksDeviceControl label={__('Position/Width', 'vayu-blocks')} classname='bold'/>}</span>

                        <div className='vayu_block_width_height_control_overlay'>

                            <UnitControl
                                label={__('Width', 'vayu-blocks')}
                                placeholder={ __( 'Auto' ) }
                                labelPosition="top"
                                size="__unstable-large"
                                className="vayu_block_unit_width_control"
                                onChange={(value) =>changevalue('width',value)}
                                value={attributes.position?.width?.[getView]}
                                max={200} // Maximum width
                                min={2} // Minimum width
                                units={[
                                    {
                                    a11yLabel: 'Percentage (%)',
                                    label: '%',
                                    step: 1,
                                    value: '%'
                                    }
                                ]}
                            />
                    
                            <UnitControl
                                label={__('Height', 'vayu-blocks')}
                                placeholder={ __( 'Auto' ) }
                                labelPosition="top"
                                size="__unstable-large"
                                className="vayu_block_unit_width_control"
                                onChange={(value) =>changevalue('height',value)}
                                value={attributes.position?.height?.[getView]}
                                max={200} // Maximum width
                                min={2} // Minimum width
                                units={[
                                    {
                                    a11yLabel: 'Percentage (%)',
                                    label: '%',
                                    step: 1,
                                    value: '%'
                                    }
                                ]}
                            />
                    
                        </div>

                        <div className='vayu_block_width_height_control_overlay'>

                                <UnitControl
                                    label={__('Left', 'vayu-blocks')}
                                    placeholder={ __( 'Auto' ) }
                                    labelPosition="top"
                                    size="__unstable-large"
                                    className="vayu_block_unit_width_control"
                                    onChange={(value) =>changevalue('left',value)}
                                    value={attributes.position?.left?.[getView]}
                                    max={1500} // Maximum width
                                    min={-500} // Minimum width
                                    units={[
                                        {
                                            a11yLabel: 'Percentage (px)',
                                            label: 'px',
                                            step: 1,
                                            value: 'px'
                                        }
                                    ]}
                                />
                            
                                <UnitControl
                                    label={__('Top', 'vayu-blocks')}
                                    placeholder={ __( 'Auto' ) }
                                    labelPosition="top"
                                    size="__unstable-large"
                                    className="vayu_block_unit_width_control"
                                    onChange={(value) =>changevalue('top',value)}
                                    value={attributes.position?.top?.[getView]}
                                    max={1500} // Maximum width
                                    min={-500} // Minimum width
                                    units={[
                                        {
                                        a11yLabel: 'Percentage (px)',
                                        label: 'px',
                                        step: 1,
                                        value: 'px'
                                        }
                                    ]}
                                />
                        </div>

                    </>

                </PanelBody>  

            </div>

    );
};

export default Overlay;